var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11 11",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7,10.5H2.3c-0.4,0-0.8-0.2-1.1-0.5C0.9,9.8,0.8,9.4,0.8,8.9V7.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.1 c0,0.1,0.1,0.3,0.2,0.4C2,9.4,2.2,9.5,2.3,9.5h6.4c0.1,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.4V7.9c0-0.3,0.2-0.5,0.5-0.5 s0.5,0.2,0.5,0.5v1.1c0,0.4-0.2,0.8-0.5,1.1C9.5,10.3,9.1,10.5,8.7,10.5z M5.5,7.9C5.2,7.9,5,7.6,5,7.4V2.2L3.2,4 C3,4.2,2.7,4.2,2.5,4s-0.2-0.5,0-0.7l2.6-2.6c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1v0c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0l0,0 c0,0,0,0,0,0c0,0,0,0,0,0h0c0,0,0,0,0,0h0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1l2.6,2.6 c0.2,0.2,0.2,0.5,0,0.7S8,4.2,7.8,4L6,2.2v5.1C6,7.6,5.8,7.9,5.5,7.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d369d1b04b26dd0366ba47421c037269.svg";
export { ForwardRef as ReactComponent };